/**
 * Build FormData
 */
export const buildFormData = (formElements) => {
  let formData = new FormData(); //reset form data on every submit to prevent doubled data
  formElements.forEach((element) => {
    //filter unchecked checkboxes and toggles
    if (element.tagName.toLowerCase() === "eon-ui-checkbox") {
      if (element.checked) {
        formData.append(element.name, element.value);
      }
    } else if (element.tagName.toLowerCase() === "eon-ui-switch-toggle") {
      if (element.checked) {
        formData.append(element.name, element.value);
      }
    } else {
      if (element.value) {
        formData.append(element.name, element.value);
      }
    }
  });
  return formData;
};
